import { useDraggable, useDroppable } from "@dnd-kit/core";
import classNames from "classnames";

const Row = ({ children, data, index, className, isDroppable, ...rest }) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef: setDraggableNodeRef,
  } = useDraggable({
    data: { ...data, index },
    id: `draggable-${rest["data-row-key"]}`,
  });

  const { isOver, setNodeRef: setDroppableNodeRef } = useDroppable({
    data: { ...data, index: index + 1 },
    id: `droppable-${rest["data-row-key"]}`,
    disabled: !isDroppable || isDragging,
  });

  const isIndicatorVisible = !isDragging && isOver;

  return (
    <tr
      {...rest}
      {...attributes}
      {...listeners}
      className={classNames(className, {
        "neeto-ui-rounded-lg hover:neeto-ui-bg-gray-100 w-full min-w-0 cursor-move transition-colors": true,
        "neeto-ui-bg-gray-100 opacity-50": isDragging,
        "neeto-ui-bg-primary-100 neeto-ui-shadow-2xs": isIndicatorVisible,
      })}
      ref={node => {
        setDraggableNodeRef(node);
        setDroppableNodeRef(node);
      }}
    >
      {children}
    </tr>
  );
};

export default Row;
